/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Already_Enabled_LimitedInputs */

const en_disabled_websites_already_enabled_limited = /** @type {(inputs: Disabled_Websites_Already_Enabled_LimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} is already enabled with limited compatibility`)
};

const es_disabled_websites_already_enabled_limited = /** @type {(inputs: Disabled_Websites_Already_Enabled_LimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} ya está habilitado con compatibilidad limitada`)
};

/**
* | output |
* | --- |
* | "{hostname} is already enabled with limited compatibility" |
*
* @param {Disabled_Websites_Already_Enabled_LimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_enabled_limited = /** @type {((inputs: Disabled_Websites_Already_Enabled_LimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Enabled_LimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_enabled_limited(inputs)
	return en_disabled_websites_already_enabled_limited(inputs)
});